import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfComponents } from '@/modules/Administracion/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
export class ComponentService extends BaseService<IConfComponents> {
  constructor () {
    super({
      baseUrl: 'system/components/'
    })
  }
  async saveComponents(
    params: IConfComponents
  ): Promise<AxiosResponse<IResponseApi<boolean>>> {
    return this.http.post<IResponseApi<boolean>>('/save-components', params).catch(this.errorHandle)
  }
  async saveMigracion(
    params: { entidades: string[], componentIds: number[] }
  ): Promise<AxiosResponse<IResponseApi<{ entidades: Array<{ entidad: string, estado: 'completada' | 'fallida', resumen?: unknown, error?: { mensaje: string, status: number } }> }>>> {
    return this.http.post('/save-migracion', params).catch(this.errorHandle)
  }
  async componentsWihtChildrens(
    id: string,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfComponents>>> {
    return this.http.get<IResponseApi<IConfComponents>>('/components-with-childrens/'+id, { params }).catch(this.errorHandle)
  }

}
